import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler } from '@angular/core';
import {
  PreloadAllModules,
  provideRouter,
  RouteReuseStrategy,
  withComponentInputBinding,
  withNavigationErrorHandler,
  withPreloading
} from '@angular/router';
import { IonicRouteStrategy } from '@ionic/angular/common';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { provideTranslateService } from '@ngx-translate/core';

import { authInterceptorFn } from '@core/interceptors/auth';
import { cacheInterceptorFn } from '@core/interceptors/cache';
import { identityHeadersInterceptorFn } from '@core/interceptors/identity-headers';
import { loaderInterceptorFn } from '@core/interceptors/loader';
import { timeoutInterceptorFn } from '@core/interceptors/timeout';
import { traceInterceptorFn } from '@core/interceptors/trace';
import { utcDateInterceptorFn } from '@core/interceptors/utc-date';
import { AppErrorHandler } from '@core/services/error-handler/error-handler';
import { isChunkLoadError, reloadForStaleChunks } from '@core/utils/chunk-reload';

import { routes } from './app-routes';
import { pageTransition } from './page-transition';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useClass: AppErrorHandler },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular({
      mode: 'ios',
      navAnimation: pageTransition,
      rippleEffect: false,
      useSetInputAPI: true
    }),
    provideRouter(
      routes,
      withPreloading(PreloadAllModules),
      withComponentInputBinding(),
      // A lazy route whose chunk hash no longer exists on the server means this tab predates the
      // latest deploy — reload into the target route so the user lands on the new build
      withNavigationErrorHandler((navigationError) => {
        if (isChunkLoadError(navigationError.error)) {
          reloadForStaleChunks(navigationError.url);
        }
      })
    ),
    provideHttpClient(
      withInterceptors([
        timeoutInterceptorFn,
        loaderInterceptorFn,
        traceInterceptorFn,
        cacheInterceptorFn,
        authInterceptorFn,
        identityHeadersInterceptorFn,
        utcDateInterceptorFn
      ])
    ),
    provideTranslateService()
  ]
};
